
import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { MessageService } from '@services/message.service';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { Subject, Subscription } from 'rxjs';
import { FlipitemtabService } from '../../services/flipitemtab.service';
import { ScoringTypeEnum, ScoringTypeName1, ScoringTypeNameEnum } from 'src/app/shared/config/questions.config';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';

export interface UserData {
  itemname: string;
  itemdescription: string;
  tags: any;
  isItemTag: boolean;
  updatedDate: any;
  updatedBy: string;
}

@Component({
  selector: 'app-tests-existing-items',
  templateUrl: './tests-existing-items.component.html',
  styleUrls: ['./tests-existing-items.component.scss']
})
export class TestsExistingItemsComponent implements OnInit, OnDestroy, AfterViewInit {
  itemServiceSubscription$: Subscription | undefined;
  itemFilterServiceSubscription$: Subscription | undefined;
  items: any;
  maxOfItemRenderOrder: any;
  sum: any;
  displayedColumns: string[] = ['itemBankName', 'scoringtype', 'styleGroup', 'questiontype', 'itemStatus', 'updated', 'tags',];
  @Output() closeExistingItemEvent = new EventEmitter<boolean>();
  searchText: any;
  page: number = 1;
  itemName = "";
  itemDescription = "";
  tagDescription = "";
  itemStatus = "";
  isItemDescended = true;
  noDataFound = false;
  isNoItems = false;
  totalRecords: any;
  testuuId: any;

  dataSource: MatTableDataSource<UserData>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selection = new SelectionModel<UserData>(true, []);
  itemRenderOrder: any = [];
  itemIds: any = [];
  itemJsonData: any = [];
  testStatusList: any;
  globalcollectionuuid: any;
  messageFlag = false;
  success = false;
  error = false;
  messages = '';
  selectedItem: any = [];
  routeSubscription: Subscription;
  ScoringTypeId: any;
  selectedGroupName: any;
  ScoringTypeNameEnum = ScoringTypeNameEnum;
  ScoringTypeName1 = ScoringTypeName1;
  styleGroupId: any;
  testdetail: any;
  itemCategoryId: any;
  ItemCategoryList: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  langCode: string;

  constructor(
    private itemService: ItemService,
    private testService: TestService,
    private router: Router,
    private actRoute: ActivatedRoute,
    private flipitemtabService: FlipitemtabService,
    private messageService: MessageService,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    private routerstate: ActivatedRoute,
    public translate: TranslateService
  ) {
    this.testService.getTestDetail.subscribe(d => {
      this.testdetail = d
    });

    this.testService.getItemCategoryList.subscribe(a => {
      this.ItemCategoryList = a;
    })
    this.langCode = localStorage.getItem('language');
  }

  @Input() itemGroupList: Array<any>;
  @Input() set selectedGroup(id: any) {
    this.selectedGroupName = id;
    if (id !== undefined) {
      this.ScoringTypeId = id.itemCategoryName == 'Others' ? sessionStorage.getItem('testScoringTypeId') : id.scoringTypeId;
      this.styleGroupId = id.styleGroupId;
      this.itemCategoryId = id.itemCategoryid;
    } else {
      this.ScoringTypeId = sessionStorage.getItem('testScoringTypeId');
      this.styleGroupId = this.testdetail.styleGroupId == null ? 0 : this.testdetail.styleGroupId;
      this.itemCategoryId = this.ItemCategoryList[0].itemCategoryid;
    }

  }

  @Input() set existingItemData(data: any) {
    this.messageService.clearMessagesNext();
    this.globalcollectionuuid = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));

    this.testService.getTestStatusList()?.subscribe(data => {
      this.testStatusList = data?.statuslist;
    },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });

    this.routerstate.paramMap.subscribe(data => {
      this.testuuId = data.get('id');
    })

    const options = '&itemStatus=Published';
    this.itemServiceSubscription$ = this.itemService.getItemByQuery(this.globalcollectionuuid, this.testuuId, options)?.subscribe(
      (data) => {
        const items = data?.data;
        this.items = items.map(e => ({ 
          ...e, 
          questionTypes: e.questionTypes[0].replace(/\r/g, ' '),
          itemCategoryId: 0 
        }));
        if (this.items.length == 0) {
          this.isNoItems = true;
        }
        this.items = new MatTableDataSource(this.items);
        this.items.sort = this.sort;
        this.items.paginator = this.paginator;
        if (this.items.paginator) {
          // ------Set translation for pagination------
          this.translate.stream([
            'testId.TabItems.existingItem.pagination.pageLabel',
            'testId.TabItems.existingItem.pagination.firstPage',
            'testId.TabItems.existingItem.pagination.lastPage',
            'testId.TabItems.existingItem.pagination.nextPage',
            'testId.TabItems.existingItem.pagination.prevPage'
          ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
            this.items.paginator._intl.itemsPerPageLabel = translation['testId.TabItems.existingItem.pagination.pageLabel'];
            this.items.paginator._intl.firstPageLabel = translation['testId.TabItems.existingItem.pagination.firstPage'];
            this.items.paginator._intl.lastPageLabel = translation['testId.TabItems.existingItem.pagination.lastPage'];
            this.items.paginator._intl.nextPageLabel = translation['testId.TabItems.existingItem.pagination.nextPage'];
            this.items.paginator._intl.previousPageLabel = translation['testId.TabItems.existingItem.pagination.prevPage'];

            this.items.paginator._intl.changes.next();
          });
        }
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    this.getItemRenderOrder()
  }

  getItemRenderOrder() {
    this.testService.getItemByTestId(this.testuuId)?.subscribe(
      (resdata) => {
        resdata.data.forEach(element => {
          this.itemRenderOrder.push(element.itemOrdertoRender);
        })
        this.maxOfItemRenderOrder = Math.max.apply(Math, this.itemRenderOrder);
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
  }

  gotoItems() {
    this.closeExistingItemEvent.emit(true);
  }

  // getItemGroupId(row: any, id: any) {
  //   row.itemCategoryId = id;
  // }

  ngAfterViewInit(): void {
    if (this.items) {
      this.items.paginator = this.paginator;
      this.items.sort = this.sort;
    }
  }

  ngOnInit(): void {
    this.testService.getUpdatedTest.subscribe(res => {
      if (res) {
        this.selectedGroupName = this.selectedGroup;
        if (this.selectedGroup !== undefined) {
          this.ScoringTypeId = this.selectedGroup.itemCategoryName == 'Others' ? sessionStorage.getItem('testScoringTypeId') : this.selectedGroup.scoringTypeId;
          this.styleGroupId = this.selectedGroup.styleGroupId;
          this.itemCategoryId = this.selectedGroup.itemCategoryid;
        } else {
          this.ScoringTypeId = sessionStorage.getItem('testScoringTypeId');
          this.styleGroupId = res.data.styleGroupId == null ? 0 : res.data.styleGroupId;
          this.itemCategoryId = this.ItemCategoryList[0].itemCategoryid;
        }

        // }
        const options = '&itemStatus=Published';
        this.itemServiceSubscription$ = this.itemService.getItemByQuery(this.globalcollectionuuid, this.testuuId, options)?.subscribe(
          (data) => {
            const items = data?.data;
            this.items = items.map(e => ({ 
              ...e,
              questionTypes: e.questionTypes[0].replace(/\r/g, ' '), 
              itemCategoryId: 0 
            }));
            if (this.items.length == 0) {
              this.isNoItems = true;
            }
            this.items = new MatTableDataSource(this.items);
            this.items.sort = this.sort;
            this.items.paginator = this.paginator;
            if (this.items.paginator) {
              // ------Set translation for pagination------
              this.translate.stream([
                'testId.TabItems.existingItem.pagination.pageLabel',
                'testId.TabItems.existingItem.pagination.firstPage',
                'testId.TabItems.existingItem.pagination.lastPage',
                'testId.TabItems.existingItem.pagination.nextPage',
                'testId.TabItems.existingItem.pagination.prevPage'
              ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                this.items.paginator._intl.itemsPerPageLabel = translation['testId.TabItems.existingItem.pagination.pageLabel'];
                this.items.paginator._intl.firstPageLabel = translation['testId.TabItems.existingItem.pagination.firstPage'];
                this.items.paginator._intl.lastPageLabel = translation['testId.TabItems.existingItem.pagination.lastPage'];
                this.items.paginator._intl.nextPageLabel = translation['testId.TabItems.existingItem.pagination.nextPage'];
                this.items.paginator._intl.previousPageLabel = translation['testId.TabItems.existingItem.pagination.prevPage'];

                this.items.paginator._intl.changes.next();
              });
            }
          },
          (error: any) => {
            this.webErrorService.handleAPIErrors(error);
          });
        this.getItemRenderOrder()
      }

    })


    // @Input() set selectedGroup(id: any) {

  }

  toggleCheckbox(event: any, selectedUser: any) {
    selectedUser.checked = event?.checked;
    selectedUser.itemCategoryId = this.itemCategoryId;
    this.itemIds.push(selectedUser);
    this.itemIds = this.itemIds.filter((c, index) => {
      return this.itemIds.indexOf(c) === index;
    });

    // if (this.itemIds.some((e: any) => e === event.source.id)) {
    //   this.itemIds = this.itemIds.filter((item: any) =>
    //     item !== event.source.id);
    // } else {
    //   this.itemIds.push(event.source);
    // }
  }

  saveItemsToTest() {
    this.messageService.getMessageNext().subscribe(data => {
      this.messageFlag = true;
      this.success = false;
      this.error = true;
      this.messages = data?.text;
    },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });

    if (this.actRoute.snapshot.paramMap.get('id')) {
      this.itemJsonData = [];
      const testuuId = this.actRoute.snapshot.paramMap.get('id');
      const itemBankIds = this.itemIds;
      this.itemIds.forEach((element: any) => {
        if (element.checked) {
          if (this.items && this.items.filteredData) {
            if (this.itemRenderOrder && this.itemRenderOrder.length) {
              this.sum = this.maxOfItemRenderOrder + element.value;
            } else {
              this.sum = element.value;
            }
            this.itemJsonData.push({
              itemBankuuId: element.itemuuid,
              itemRenderOrder: 0,
              itemGroupId: element.itemCategoryId
            });
          }
        }
      });
      if (this.itemJsonData.length > 0) {
        this.testService.addItemToTest(testuuId, itemBankIds, this.itemJsonData).subscribe(resData => {
          if (resData.data.length > 0) {
            this.notificationService.success(resData?.message);
            this.flipitemtabService.emit<boolean>(false);
            this.closeExistingItemEvent.emit(true);
          }
        },
          (error: any) => {
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          });

      }
    }
  }


  itemFilter(): void {
    const testuuId = this.actRoute.snapshot.paramMap.get('id');
    const filterObj = {
      collectionuuid: this.globalcollectionuuid,
      testuuId: testuuId,
      itemName: this.itemName,
      itemDescription: this.itemDescription,
      tag: this.tagDescription,
      itemStatus: this.itemStatus
    };
    this.itemFilterServiceSubscription$ = this.itemService.getItemTestFilter(filterObj)?.subscribe(
      (resData) => {
        this.items = resData?.data;
        if (this.items.length == 0) {
          this.noDataFound = true;
        }
        this.items = this.items.map(e => ({ 
          ...e, 
          questionTypes: e.questionTypes[0].replace(/\r/g, ' '), 
        }));
        this.items = new MatTableDataSource(this.items);
        this.items.sort = this.sort;
        this.items.paginator = this.paginator;
      },
      (error) => {
        this.isNoItems = true;
        this.webErrorService.handleAPIErrors(error);
      },
      () => {
      }) || undefined;
    this.noDataFound = false;
  }

  onChangePage(pageOfItems: Array<any>) {
    this.totalRecords = this.items.length;
  }

  resetFilter() {
    this.itemIds = [];
    this.itemName = "";
    this.itemDescription = ""
    this.itemStatus = "";
    this.tagDescription = "";
    this.noDataFound = false;
    const options = '&itemStatus=Published';
    this.itemServiceSubscription$ = this.itemService.getItemByQuery(this.globalcollectionuuid, this.testuuId, options)?.subscribe(
      (data) => {
        this.items = data?.data;
        this.items = this.items.map(e => ({ 
          ...e, 
          questionTypes: e.questionTypes[0].replace(/\r/g, ' '), 
        }));
        this.items = new MatTableDataSource(this.items);
        this.items.sort = this.sort;
        this.items.paginator = this.paginator;
        if (this.items.paginator.paginator) {
          this.items.paginator.paginator.firstPage();
        }
      },
      (error) => {
        this.router.navigate(["/login"]);
      },
      () => {
      }) || undefined;
  }

  navigateToItemDetails(id: any) {
    this.router.navigate(["/tests-details", id]);
  }

  createNewItem() {
    this.router.navigate(["../../create-new-item"], { relativeTo: this.actRoute });
  }

  ngOnDestroy() {
    if (this.itemServiceSubscription$) {
      this.itemServiceSubscription$.unsubscribe();
    }
    if (this.itemFilterServiceSubscription$) {
      this.itemFilterServiceSubscription$.unsubscribe();
    }

    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
